
import { DataGridPro } from '@mui/x-data-grid-pro';

import { useTranslation } from 'react-i18next';
import React, { useEffect, useState } from 'react';

import BeatLoader from 'react-spinners/BeatLoader';

import _ from 'lodash';
import copy from 'fast-copy';
import { colors } from '../../../../Shared/utils';
import { LinearProgress as LoadingOverlay, MenuItem } from '@material-ui/core';

import { useAppContext } from '../../../../Context/App/Provider';

import {
  getWidgets, updateWidgets
} from '../../../../Functions/widgets';

import { makeStyles } from '@material-ui/core/styles';
import Menu from '@material-ui/core/Menu';

import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';

import {
  getWidgetDataForImageDeployment, getWidgetDataForDeviceErasure,
  getWidgetDataForDiskErasurePerCapacity, getWidgetDataForDiskErasurePerProtocol,
  getWidgetDataForDiskErasurePerBrand, getWidgetDataForDiskErasurePerBrandAndModel,
  getWidgetDataForDiagnostics, getWidgetDataForDiagnosticsPerTest,
  getWidgetDataForDisksErasurePerCapacity, getWidgetDataForDisksErasurePerProtocol,
  getWidgetDataForDisksErasurePerBrand, getWidgetDataForDisksErasurePerBrandAndModel,
  getWidgetDataForImageCapture, getWidgetDataForImageCapturePerOS
} from '../WidgetsData';

import './ReportingSubCharts.css';
import '../../../SweetAlert.css'

const line_separator = " / ";

function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}
async function pauseMe(millis) {
  await sleep(millis);
}


export default function ReportingSubCharts({ deployments, loading, rows, settings, scenario, columns, sidebar, selectionModel }) {
  const { t } = useTranslation();
  const [{ storedEnabledWidgets }, appDispatch] = useAppContext();

  const [availableWidgets, setAvailableWidgets] = useState([]);
  const [enabledWidgets, setEnabledWidgets] = useState(storedEnabledWidgets ? storedEnabledWidgets : []);

  const [prevScenario, setPrevScenario] = useState(scenario);
  const [prevColumns, setPrevColumns] = useState(columns);

  const [items, setItems] = useState([]);

  const defaultColumns = [    //Passed	Failed	Other	Total
    {
      field: 'firstColumn',
      headerName: ' ',
      width: 150,
      editable: false,
      resizable: false,
      disableColumnMenu: true,
      disableReorder: true,
      sortable: false,
      headerAlign: 'left',
      align: 'left',
      renderCell: ({ row }) => {
        if (row.firstColumn) {
          return (
            <span >
              {row.firstColumn}
            </span>
          )
        }
      }
    },
    {
      field: 'passed',
      headerName: t('reporting.columns.statistics.passed'),
      width: 90,
      editable: false,
      resizable: false,
      disableColumnMenu: true,
      disableReorder: true,
      sortable: false,
      headerAlign: 'right',
      align: 'right',
      renderCell: ({ row }) => {
        if (row.passed) {
          // <span style={{ fontStyle:(row.cumulRow ? 'italic' : "inherit")}}>
          return (
            <span>
              {row.passed}
            </span>
          )
        }
      }
    },
    {
      field: 'failed',
      headerName: t('reporting.columns.statistics.failed'),
      width: 90,
      editable: false,
      resizable: false,
      disableColumnMenu: true,
      disableReorder: true,
      sortable: false,
      headerAlign: 'right',
      align: 'right',
      renderCell: ({ row }) => {
        if (row.failed) {
          return (
            <span>
              {row.failed}
            </span>
          )
        }
      }
    },
    {
      field: 'other',
      headerName: t('reporting.columns.statistics.other'),
      width: 90,
      editable: false,
      resizable: false,
      disableColumnMenu: true,
      disableReorder: true,
      sortable: false,
      headerAlign: 'right',
      align: 'right',
      renderCell: ({ row }) => {
        if (row.other) {
          return (
            <span>
              {row.other}
            </span>
          )
        }
      }
    },
    {
      field: 'total',
      headerName: t('reporting.columns.statistics.total'),
      width: 90,
      editable: false,
      resizable: false,
      disableColumnMenu: true,
      disableReorder: true,
      sortable: false,
      headerAlign: 'right',
      align: 'right',
      renderCell: ({ row }) => {
        if (row.total) {
          return (
            <span>
              {row.total}
            </span>
          )
        }
      }
    }
  ];


  //-------------------    
  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
  };


  const getItemStyle = (isDragging, draggableStyle) => ({
    userSelect: 'none',
    background: isDragging ? 'rgba(255, 255, 255, 0)' : 'inherit',
    ...draggableStyle,
  });

  const getListStyle = isDraggingOver => ({
    display: 'flex',
    overflow: 'auto',
    gap: '5px'
  });


  const onDragEnd = (result) => {
    // dropped outside the list
    if (!result.destination) {
      return;
    }

    const newItems = reorder(
      items,
      result.source.index,
      result.destination.index
    );
    setItems(newItems);


    const newEnabledWidgetsTmp = reorder(
      enabledWidgets,
      result.source.index,
      result.destination.index
    );
    setEnabledWidgets(newEnabledWidgetsTmp);
    appDispatch({ storedEnabledWidgets: newEnabledWidgetsTmp });

    updateWidgets(newEnabledWidgetsTmp, scenario && scenario.id, 'reporting').then(res => {
      // if (!res.success) {
      //   return toast(t('settings.columns.error'), { type: 'error' });
      // }
      // toast(t('settings.columns.success'), { type: 'success' });
    });
  }
  //-------------------


  // console.log("35 - loading=", loading);
  // console.log("36 - rows=", rows);
  // console.log("37 - settings=", settings);
  // console.log("38 - scenario=", scenario);
  // console.log("39 - devicesType=", scenario && scenario.devicesType);
  // console.log("40 - columns=", columns);
  // console.log("41 - deployments=", deployments);


  const devicesType = scenario && scenario.devicesType;


  const useStyles = makeStyles((theme) => ({
    root: {
      backgroundColor: theme.palette.background.paper,
    },
  }));

  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);


  async function initWidgets(availableWidgets) {
    // console.log("251 - initWidgets...", scenario);

    if (scenario === null)
      return;

    const devicesType = scenario && scenario.devicesType;

    const ret = await getWidgets(
      scenario && scenario.id, scenario && scenario.devicesType
    );

    // console.log("257 - ret=", ret);

    let loadSaved = false;
    let widgetsFromDatabase = [];
    if (ret && ret.widgets && ret.widgets[0] && ret.widgets[0].Widgets) {
      loadSaved = true;
    widgetsFromDatabase = JSON.parse(ret.widgets[0].Widgets);
    }

    // console.log("272 - columns=", columns);

    const deploymentsCategory = columns.find(col => {
      return col.field && col.field.substring(0, 15) === "deployments_$$_";
    }) || false;

    const imagingCategory = columns.find(col => {
      return col.field && col.field.substring(0, 11) === "imaging_$$_";
    }) || false;

    const diagnosticsCategory = columns.find(col => {
      return col.field && col.field.substring(0, 5) === "diag_";
    }) || false;

    const deviceWipeCategory = columns.find(col => {
      return col.field && col.field.substring(0, 15) === "device_wipe_$$_";
    }) || false;

    const diskWipeCategory = columns.find(col => {
      return col.field && col.field.substring(0, 13) === "disk_wipe_$$_";
    }) || false;

    const disksWipeCategory = columns.find(col => {
      return col.field && col.field.substring(0, 14) === "disks_wipe_$$_";
    }) || false;

    // const availableWidgetsTmp = [];
    const enabledWidgetsTmp = [];

    if (devicesType === 0) {
      /*
        IF the view contains any Diagnostics category column, display by default Diagnostics statistics widgets
        IF the view contains any Deployment category column, display by default Deployment statistics widgets
        IF the view contains any Device wipe category column, display by default Device erasure statistics widgets
        IF the view contains any Disk wipe category column, display by default Disk erasure statistics widgets
      */
      // Diagnostics
      // availableWidgetsTmp.push("diagnostics");
      // availableWidgetsTmp.push("diagnostics_per_test");

      if (diagnosticsCategory) {
        enabledWidgetsTmp.push("diagnostics");
        enabledWidgetsTmp.push("diagnostics_per_test");
      }

      if (deploymentsCategory) {
        enabledWidgetsTmp.push("image_deployment");
      }

      if (imagingCategory) {
        enabledWidgetsTmp.push("image_capture");
        enabledWidgetsTmp.push("image_capture_per_os");
      }

      // Device erasure
      // availableWidgetsTmp.push("device_erasure");

      if (deviceWipeCategory) {
        enabledWidgetsTmp.push("device_erasure");
      }

      // Disk erasure
      // availableWidgetsTmp.push("disk_erasure_per_capacity");
      // availableWidgetsTmp.push("disk_erasure_per_protocol");
      // availableWidgetsTmp.push("disk_erasure_per_brand");
      // availableWidgetsTmp.push("disk_erasure_per_brand_and_model");

      if (diskWipeCategory) {
        enabledWidgetsTmp.push("disk_erasure_per_capacity");
        enabledWidgetsTmp.push("disk_erasure_per_protocol");
        enabledWidgetsTmp.push("disk_erasure_per_brand");
        enabledWidgetsTmp.push("disk_erasure_per_brand_and_model");
      }
    }
    else if (devicesType === 1) {

    }
    else if (devicesType === 2) {
      // Disk erasure
      // availableWidgetsTmp.push("disks_erasure_per_capacity");
      // availableWidgetsTmp.push("disks_erasure_per_protocol");
      // availableWidgetsTmp.push("disks_erasure_per_brand");
      // availableWidgetsTmp.push("disks_erasure_per_brand_and_model");

      if (disksWipeCategory) {
        enabledWidgetsTmp.push("disks_erasure_per_capacity");
        enabledWidgetsTmp.push("disks_erasure_per_protocol");
        enabledWidgetsTmp.push("disks_erasure_per_brand");
        enabledWidgetsTmp.push("disks_erasure_per_brand_and_model");
      }
    }
    // setAvailableWidgets(availableWidgetsTmp);

    // console.log("339 - enabledWidgets=", enabledWidgets);
    // console.log("340 - enabledWidgetsTmp=", enabledWidgetsTmp);

    const includesAll = (arr, values) => values.every(v => arr.includes(v));
    // // console.log("341 - includesAll=", includesAll(availableWidgetsTmp, enabledWidgets));

    // console.log("354 - availableWidgets=", availableWidgets);
    // console.log("355 - widgetsFromDatabase=", widgetsFromDatabase);

    if (widgetsFromDatabase && includesAll(availableWidgets, widgetsFromDatabase) && loadSaved) {
      setEnabledWidgets(widgetsFromDatabase);
      appDispatch({ storedEnabledWidgets: widgetsFromDatabase });
    }
    else {
      // console.log("362 - enabledWidgetsTmp=", enabledWidgetsTmp);

    setEnabledWidgets(enabledWidgetsTmp);
      appDispatch({ storedEnabledWidgets: enabledWidgetsTmp });
    }
  }


  useEffect(() => {
    if (JSON.stringify(prevScenario) !== JSON.stringify(scenario)) {
      setPrevScenario(scenario);
    }
  }, [scenario])


  useEffect(() => {
    if (JSON.stringify(prevColumns) !== JSON.stringify(columns)) {
      setPrevColumns(columns);
    }
  }, [columns])


  useEffect(() => {

    const devicesType = scenario && scenario.devicesType;
    const availableWidgetsTmp = [];

    if (devicesType === 0) {

      // Diagnostics
      availableWidgetsTmp.push("diagnostics");
      availableWidgetsTmp.push("diagnostics_per_test");

      // Deployment
      availableWidgetsTmp.push("image_deployment");

      // Capture
      availableWidgetsTmp.push("image_capture");
      availableWidgetsTmp.push("image_capture_per_os");

      // Device erasure
      availableWidgetsTmp.push("device_erasure");

      // Disk erasure
      availableWidgetsTmp.push("disk_erasure_per_capacity");
      availableWidgetsTmp.push("disk_erasure_per_protocol");
      availableWidgetsTmp.push("disk_erasure_per_brand");
      availableWidgetsTmp.push("disk_erasure_per_brand_and_model");
    }
    else if (devicesType === 1) {

    }
    else if (devicesType === 2) {
      // Disk erasure
      availableWidgetsTmp.push("disks_erasure_per_capacity");
      availableWidgetsTmp.push("disks_erasure_per_protocol");
      availableWidgetsTmp.push("disks_erasure_per_brand");
      availableWidgetsTmp.push("disks_erasure_per_brand_and_model");
    }
    // console.log("415 - availableWidgetsTmp=", availableWidgetsTmp);
    setAvailableWidgets(availableWidgetsTmp);

    initWidgets(availableWidgetsTmp);

  }, [prevScenario, prevColumns]);


  useEffect(() => {
    const itemsTmp = [];

    // console.log("425 - enabledWidgets=", enabledWidgets);
    // console.log("426 - devicesType=", devicesType);

    const selectedRows = selectionModel.length === 0 ? rows : rows.filter((row) => {
      return selectionModel.includes(row.key + 1);
    });

    if (devicesType === 0) {

      // console.log("431 - enabledWidgets=", enabledWidgets);

      enabledWidgets.map(widget => {
        const item = {
          id: null,
          content: (
            <div></div>
          )
        }

        let widgetColumns = [];
        let widgetRows = [];

        let firstColumnWidth = 160;
        let widgetWidth = 360 + 160; //320;
        let title = "";

        title = t('reporting.columns.statistics.' + widget);

        widgetColumns = copy(defaultColumns);
        if (widget === "diagnostics") {
          firstColumnWidth = 200;
          widgetWidth = 360 + 200 + 40; //630;
          widgetRows = getWidgetDataForDiagnostics({ rows: selectedRows, deployments, t, scenario });
        }
        else if (widget === "diagnostics_per_test") {
          firstColumnWidth = 360;
          widgetWidth = 360 + 360 + 40; //630;
          widgetRows = getWidgetDataForDiagnosticsPerTest({ rows: selectedRows, deployments, t, scenario });
        }
        else if (widget === "image_deployment") {
          firstColumnWidth = 160;
          widgetWidth = 360 + 160 + 40; //630;
          widgetRows = getWidgetDataForImageDeployment({ rows: selectedRows, deployments, t, scenario });
        }
        else if (widget === "image_capture") {
          firstColumnWidth = 160;
          widgetWidth = 360 + 160 + 40; //630;
          widgetRows = getWidgetDataForImageCapture({ rows: selectedRows, deployments, t, scenario });
        }
        else if (widget === "image_capture_per_os") {
          firstColumnWidth = 160;
          widgetWidth = 360 + 160 + 40; //630;
          widgetRows = getWidgetDataForImageCapturePerOS({ rows: selectedRows, deployments, t, scenario });
        }      
        else if (widget === "device_erasure") {
          firstColumnWidth = 320;
          widgetWidth = 360 + 320 + 40; //790;
          widgetRows = getWidgetDataForDeviceErasure({ rows: selectedRows, deployments, t, scenario });
        }
        else if (widget === "disk_erasure_per_capacity") {
          widgetColumns[0].headerName = t('reporting.columns.statistics.disk_capacity');
          firstColumnWidth = 200;
          widgetWidth = 360 + 200 + 40; //790;
          widgetRows = getWidgetDataForDiskErasurePerCapacity({ rows: selectedRows, deployments, t, scenario });
        }
        else if (widget === "disk_erasure_per_protocol") {
          widgetColumns[0].headerName = t('reporting.columns.statistics.erasure_protocol');
          firstColumnWidth = 260;
          widgetWidth = 360 + 260 + 40; //790;
          widgetRows = getWidgetDataForDiskErasurePerProtocol({ rows: selectedRows, deployments, t, scenario });
        }
        else if (widget === "disk_erasure_per_brand") {
          widgetColumns[0].headerName = t('reporting.columns.statistics.disk_brand');
          firstColumnWidth = 200;
          widgetWidth = 360 + 200 + 40; //790;
          widgetRows = getWidgetDataForDiskErasurePerBrand({ rows: selectedRows, deployments, t, scenario });
        }
        else if (widget === "disk_erasure_per_brand_and_model") {
          widgetColumns[0].headerName = t('reporting.columns.statistics.disk_brand_and_model');
          firstColumnWidth = 380;
          widgetWidth = 360 + 380 + 40; //790;
          widgetRows = getWidgetDataForDiskErasurePerBrandAndModel({ rows: selectedRows, deployments, t, scenario });
        }

        widgetColumns[0].width = firstColumnWidth;
        // console.log('417 - widgetColumns=', widgetColumns);

        item.id = widget
        item.content = (
          <div
            className="reportingSubCharts"
            style={{ height: "100%", width: widgetWidth }}
          >
            <DataGridPro
              columns={widgetColumns}
              rows={widgetRows}
              loading={loading && widgetRows.length === 0}
              disableSelectionOnClick
              headerHeight={28}
              rowHeight={32}

              components={{
                LoadingOverlay,
                Toolbar: () => (
                  <div className="content__header">
                    <h3>
                      {title}
                    </h3>

                    <button
                      onClick={() => handleCloseWidget(widget)}
                      className="button icon"
                      title={t('global.close')}
                    >
                      <span className="material-icons-round">close</span>
                    </button>
                  </div>
                ),
                Footer: () => (
                  <div className="datagrid__footer">
                  </div>
                )
              }}
            />
          </div>
        )
        itemsTmp.push(item);
      })
    }
    else if (devicesType === 1) {



    }
    else if (devicesType === 2) {

      // console.log("548 - enabledWidgets=", enabledWidgets);

      enabledWidgets.map(widget => {
        const item = {
          id: null,
          content: (
            <div></div>
          )
        }

        let widgetColumns = [];
        let widgetRows = [];

        let firstColumnWidth = 160;
        let widgetWidth = 360 + 160; //320;
        let title = "";

        title = t('reporting.columns.statistics.' + widget);

        widgetColumns = copy(defaultColumns);
        if (widget === "disks_erasure_per_capacity") {
          widgetColumns[0].headerName = t('reporting.columns.statistics.disk_capacity');
          firstColumnWidth = 200;
          widgetWidth = 360 + 200 + 40; //790;
          widgetRows = getWidgetDataForDisksErasurePerCapacity({ rows: selectedRows, deployments, t });
        }
        else if (widget === "disks_erasure_per_protocol") {
          widgetColumns[0].headerName = t('reporting.columns.statistics.erasure_protocol');
          firstColumnWidth = 260;
          widgetWidth = 360 + 260 + 40; //790;
          widgetRows = getWidgetDataForDisksErasurePerProtocol({ rows: selectedRows, deployments, t });
        }
        else if (widget === "disks_erasure_per_brand") {
          widgetColumns[0].headerName = t('reporting.columns.statistics.disk_brand');
          firstColumnWidth = 200;
          widgetWidth = 360 + 200 + 40; //790;
          widgetRows = getWidgetDataForDisksErasurePerBrand({ rows: selectedRows, deployments, t });
        }
        else if (widget === "disks_erasure_per_brand_and_model") {
          widgetColumns[0].headerName = t('reporting.columns.statistics.disk_brand_and_model');
          firstColumnWidth = 380;
          widgetWidth = 360 + 380 + 40; //790;
          widgetRows = getWidgetDataForDisksErasurePerBrandAndModel({ rows: selectedRows, deployments, t });
        }

        widgetColumns[0].width = firstColumnWidth;
        item.id = widget
        item.content = (
          <div
            className="reportingSubCharts"
            style={{ height: "100%", width: widgetWidth }}
          >
            <DataGridPro
              columns={widgetColumns}
              rows={widgetRows}
              loading={loading && widgetRows.length === 0}
              disableSelectionOnClick
              headerHeight={28}
              rowHeight={32}

              components={{
                LoadingOverlay,
                Toolbar: () => (
                  <div className="content__header">
                    <h3>
                      {title}
                    </h3>

                    <button
                      onClick={() => handleCloseWidget(widget)}
                      className="button icon"
                      title={t('global.close')}
                    >
                      <span className="material-icons-round">close</span>
                    </button>
                  </div>
                ),
                Footer: () => (
                  <div className="datagrid__footer">
                  </div>
                )
              }}
            />
          </div>
        )
        itemsTmp.push(item);
      })
    }
    setItems(itemsTmp);

  }, [enabledWidgets, rows, selectionModel]);



  const handleClickListItem = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuItemClick = (event, index, option) => {
    const enabledWidgetsTmp = [];
    for (const w of enabledWidgets) {
      enabledWidgetsTmp.push(w);
    }
    enabledWidgetsTmp.push(option);
    setEnabledWidgets(enabledWidgetsTmp);
    appDispatch({ storedEnabledWidgets: enabledWidgetsTmp });

    updateWidgets(enabledWidgetsTmp, scenario && scenario.id, 'reporting').then(res => {
      // if (!res.success) {
      //   return toast(t('settings.columns.error'), { type: 'error' });
      // }
      // toast(t('settings.columns.success'), { type: 'success' });
    });

    setAnchorEl(null);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };


  const handleCloseWidget = (widget) => {
    const enabledWidgetsTmp = [];
    for (const w of enabledWidgets) {
      if (w !== widget)
        enabledWidgetsTmp.push(w);
    }
    setEnabledWidgets(enabledWidgetsTmp);
    appDispatch({ storedEnabledWidgets: enabledWidgetsTmp });

    updateWidgets(enabledWidgetsTmp, scenario && scenario.id, 'reporting').then(res => {
      // if (!res.success) {
      //   return toast(t('settings.columns.error'), { type: 'error' });
      // }
      // toast(t('settings.columns.success'), { type: 'success' });
    });
  };


  // console.log("684 - items=", items);

  let options = availableWidgets.filter(x => !enabledWidgets.includes(x));
  const classNameSubCharts = sidebar ? "reportingSubCharts__container_with_sidebar" : "reportingSubCharts__container_without_sidebar";

  return (
    <div
      className={classNameSubCharts}
    >
      <div className={classes.root}>
        <Menu
          id="lock-menu"
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={handleClose}
        >
          {options.map((option, index) => (
            <MenuItem
              key={option}
              value={option}
              onClick={(event) => handleMenuItemClick(event, index, option)}
            >
              {t('reporting.columns.statistics.' + option)}
            </MenuItem>
          ))}
        </Menu>
      </div>

      <div
        className="col"
        style={{ height: "100%", margin: "0px 5px 0px 10px" }}
      >
        <button
          style={{
            height: "100%",
            border: "1px solid rgba(224, 224, 224, 1)",
            borderRadius: "10px"
          }}
          disabled={loading || !options || (options && options.length === 0)}
          onClick={handleClickListItem}
          className="button icon"
          title={t('reporting.columns.statistics.add_widgets')}
        >
          <span className="material-icons-round">add_circle_outline</span>
        </button>
      </div>

      {(loading || !options) ? (
        <div className="loader">
          <BeatLoader color={colors.softthinks}></BeatLoader>
        </div>
      ) : (

        <DragDropContext onDragEnd={onDragEnd} style={{ width: "100%" }}>
          <Droppable droppableId="droppable" direction="horizontal">
            {(provided, snapshot) => (
              <div
                ref={provided.innerRef}
                style={getListStyle(snapshot.isDraggingOver)}
                {...provided.droppableProps}
              >
                {items.map((item, index) => (
                  <Draggable key={item.id} draggableId={item.id} index={index}>
                    {(provided, snapshot) => (
                      <div
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        style={getItemStyle(
                          snapshot.isDragging,
                          provided.draggableProps.style
                        )}
                      >
                        {item.content}
                      </div>
                    )}
                  </Draggable>
                ))}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>
      )}
    </div>
  );
}
